import {GameCreationParams} from '../../models/game-creation-params';
import {GameCreationParamsDto} from '../dto/game-creation-params.dto';

export function convertCreateGameParamsDtoToModel(dto: GameCreationParams): GameCreationParamsDto {
  return {
    SourceBatchNumber: dto.sourceBatchNumber,
    SourceBatchID: dto.sourceBatchId,
  };
}
